<template>
  <form class="test-form" @submit.prevent="onSubmit">
    <b-loading v-if="tests.loadingSelected" active :is-full-page="false" />
    <mc-error-layout
      v-else-if="tests.selectError"
      message="Failed to load test!"
      :retry-fn="() => selectTest(id)"
    />
    <div v-else class="test-form__body">
      <b-field label="Name">
        <b-input
          v-model="tests.selected.name"
          icon="format-title"
          placeholder="Name"
          type="text"
        />
      </b-field>
      <b-field class="test-form__questions" label="Questions">
        <mc-dnd-list
          v-if="attached.length > 0"
          container-class="test-form__list"
          :list="attached"
          :on-drop="moveQuestionHandler"
          enable-numbering
        >
          <template #item="{ item }">
            <question-item attached owner="tests" :question="item" />
          </template>
        </mc-dnd-list>
        <div v-else class="test-form__message">
          There are no questions in this step
        </div>
        <b-button
          class="is-fullwidth"
          :loading="questions.submitting"
          type="is-light"
          @click="addQuestionHandler"
        >
          Add Question
        </b-button>
      </b-field>
      <div v-if="detached.length > 0" class="test-form__detached">
        <div class="test-form__detached-title title is-6">
          Unattached Questions
        </div>
        <question-item
          v-for="(question, index) in detached"
          :key="index"
          :attached="false"
          owner="tests"
          :question="question"
        />
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import con from '../../store/mutationTypes';
import QuestionItem from '../../ui/QuestionItem';

export default {
  props: {
    id: String,
    onSubmit: {
      type: Function,
      // eslint-disable-next-line
      default: () => {
        /* Does nothing */
      }
    }
  },
  computed: {
    ...mapState(['questions', 'tests']),
    ...mapGetters('tests', ['attached', 'detached'])
  },
  methods: {
    ...mapActions('questions', ['addQuestion', 'selectQuestion']),
    ...mapActions('tests', ['moveReference', 'selectTest']),
    async addQuestionHandler() {
      try {
        await this.addQuestion('tests');
        this.$store.commit(con.QUESTION_EDITOR_SET_NAMESPACED, {
          questionId: this.questions.newQuestionId,
          questionType: 'question'
        });
        this.selectQuestion(this.questions.newQuestionId);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to add question!',
          type: 'is-danger'
        });
      }
    },
    async moveQuestionHandler({ fromItem, toItem }) {
      try {
        const from = `questions/${fromItem.id}`;
        const to = `questions/${toItem.id}`;
        await this.moveReference({ from, to });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to move question!',
          type: 'is-danger'
        });
      }
    },
    async submit() {
      this.onSubmit();
    }
  },
  components: {
    QuestionItem
  },
  created() {
    this.selectTest(this.id);
  }
};
</script>

<style lang="scss" scoped>
.test-form {
  position: relative;
  height: 100%;

  &__body {
    padding: 1rem;
  }

  &__questions {
    display: flex;
    flex-direction: column;
  }

  &__list {
    margin: 0.5rem 0;
    // Overrides default dnd styles
    & /deep/ .dnd {
      &__draggable {
        box-shadow: none;
        padding: 0.5rem;
        border: 1px solid $border-color;
      }
    }
  }

  &__message {
    padding: 1rem;
    text-align: center;
  }

  &__detached {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
  }

  &__detached-title {
    text-align: center;
    padding: 1rem;
    margin-bottom: 0;
  }
}
</style>
